import React, {Component} from 'react';
import styled from 'styled-components/macro'
import saveAs from 'file-saver';
import autosizeInput from 'autosize-input';

import { ButtonDownload } from './Buttons';

const Container = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  height: 80px;
  align-items: center;
  justify-content: center;
`

const Bottombar = styled.div`
  background-color: ${({theme}) => theme.color};
  border-radius: 40px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
`

const Input = styled.input`
  height: 40px;
  font-size: 21px;
  background-color: ${({theme}) => theme.color};
  border: none;
  color: ${({theme}) => theme.bg};
  margin: 0 0 0 16px;
  text-align: left;
  outline: none;
`

class ExportMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {value: 'filename'};
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleKey = this.handleKey.bind(this);
    this.buttonOnClick = this.buttonOnClick.bind(this);
    this.input = React.createRef();
  }

  componentDidMount(){
    autosizeInput(this.input.current, { minWidth: true });
    this.input.current.focus();
  }

  handleChange(e) {
    this.setState({value: e.target.value });
  }

  handleClick(e) {
    e.stopPropagation();
  }

  handleKey(e) {
    if(e.keyCode === 13 ){
      let svg = document.getElementById("svgfile").outerHTML;
      let blob = new Blob([svg], {type: 'image/svg+xml'});
      saveAs(blob, this.state.value);
      this.props.closeModal();
    }
  }


  buttonOnClick(){
    let svg = document.getElementById("svgfile").outerHTML;
    let blob = new Blob([svg], {type: 'image/svg+xml'});
    saveAs(blob, this.state.value);
    this.props.closeModal();
  }

  render() {
    return (
      <Container>
        <Bottombar>
          <Input
            size={8}
            ref={this.input}
            type="text"
            spellCheck="false"
            value={this.state.value}
            placeholder={this.state.value}
            onClick={this.handleClick}
            onChange={this.handleChange}
            onKeyDown={this.handleKey}
          />
          <ButtonDownload small margin="0" handleClick={this.buttonOnClick}/>
        </Bottombar>
      </Container>
    );
  }
}

export default ExportMenu;